<template>
    <b-icon :icon="icon" :variant="variant" :title="title"></b-icon>
</template>

<script>
import moment from 'moment';

export default {
    name: 'DepartureTransferState',
    props: ['startTime', 'endTime'],
    computed: {
        icon() {
            var state = this.state();
            if (state == 'active' || state == 'pending') {
                return 'check-square-fill';
            }
            return 'dash-square-fill';
        },
        variant() {
            var state = this.state();
            if (state == 'active') {
                return 'success';
            }
            if (state == 'pending') {
                return 'warning';
            }
            return 'secondary';
        },
        title() {
            var state = this.state();
            if (state == 'active') {
                return this.$t('departure_transfers.state.active');
            }
            if (state == 'pending') {
                return this.$t('departure_transfers.state.pending');
            }
            return this.$t('departure_transfers.state.past');
        }
    },
    methods: {
        state() {
            var now = new moment();
            if (now.isAfter(new moment(this.endTime, 'YYYY-MM-DD[T]HH:mm:ssZZ'))) {
                return 'past';
            } else if (now.isBefore(new moment(this.startTime, 'YYYY-MM-DD[T]HH:mm:ssZZ'))) {
                return 'pending';
            }
			return 'active';
        }
    }
}
</script>